import { watchImmediate } from '@vueuse/core';
import { ref } from 'vue';
import { useTheme as useVuetifyTheme } from 'vuetify';

// TODO: rollback this once we have a way to handle both themes
// import also useTheme
import { Locale, Theme, useLocale } from '@silae/composables';
// import { useBackendHttpService } from '~/api';
import { getAppInsights, getPostHogInstance, updateLuxonConfiguration } from '~/plugins';
import { useTrackingService } from '~/services';
import { parseEnvVariable } from '~/utils';

/***
 Init backend properties
 */
// export function initBackend(): void {
// 	const { setBackendURL, setWithCredentials } = useBackendHttpService();

// 	setBackendURL(import.meta.env.SILAE_BACKEND_URL);
// 	setWithCredentials(true);
// }

/***
 Init locale update hooks
 */
export function initLocale(): void {
	const onLocaleUpdate = (locale: Locale): void => {
		updateLuxonConfiguration({ locale: locale.value });
	};
	useLocale(onLocaleUpdate);
}

/***
 Ensure Vuetify theme is sync with app theme
 */
export function initThemeSync(): void {
	// TODO: rollback this once we have a way to handle both themes
	//const { theme } = useTheme();
	const theme = ref(Theme.LIGHT);  // by default its dark mode, to add back when handling both themes const { theme }
	localStorage.setItem('sk-theme', theme.value); // to delete when puting back normal process
	const vuetifyTheme = useVuetifyTheme();
	watchImmediate(theme, theme => (vuetifyTheme.global.name.value = theme));
}

/***
 Set and clear tracking user context on sign-in and sign-out
 */
export function initUserTracking() {
	const isAuthenticated = ref(false);
	const principal = ref({});

	const { initAppInsights, initPostHog, setUserContext, clearUserContext } = useTrackingService();

	const enableAppInsights = parseEnvVariable(import.meta.env.SILAE_APP_INSIGHTS_ENABLED);
	if (enableAppInsights) {
		const appInsights = getAppInsights();
		initAppInsights(appInsights);
	}

	// PostHog is now initialized from runtime config, not build-time env vars
	getPostHogInstance().then(hog => {
		if (hog) {
			initPostHog(hog);
		}
	}).catch(error => {
		console.error('Failed to initialize PostHog in user tracking:', error);
	});

	watchImmediate(
		() => ({
			isAuthenticated: isAuthenticated.value,
			principal: principal.value
		}),
		({ isAuthenticated, principal }, former) => {
			if (isAuthenticated && !former?.isAuthenticated) {
				setUserContext(principal);
			}

			if (!isAuthenticated && former?.isAuthenticated) {
				clearUserContext();
			}
		}
	);
}
